import * as FIELD_NAME from 'constant/form-item-names'
import React from 'react'
import { Form, Checkbox } from 'antd'

const Draft = () => {
  return (
    <Form.Item
      noStyle
    >
      <Form.Item
        name={FIELD_NAME.DRAFT}
        valuePropName='checked'
      >
        <Checkbox >Draft</Checkbox>
      </Form.Item>
    </Form.Item>
  )
}
export default Draft
